export default {
      id: "modal-result-usage",
      viewBox: "0 0 64 65",
      url: __webpack_public_path__ + "assets/img/svg/sprite.svg#modal-result",
      toString: function () {
        return this.url;
      }
    }